/**
 * @desc 阶段批量处理(调拨单已发运后到FBA仓入库)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: Array<defs.basics.TimelinessDashboardProcessPhaseRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/timelinessDashboard/batchProcessPhaseLogistics`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
